// Página admin de White Labels (superAdmin) — wave 1: lista em grid
// de cards com busca e paginação. Layout padrão de página admin.
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { WhiteLabelsList } from "@/features/white-label-admin"

export function WhiteLabelsPage() {
  const { t } = useTranslation()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t("sidebar.administration"),
            },
            {
              label: t("sidebar.whiteLabels"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <div className="flex flex-col gap-1">
          <h1 className="page-title">
            {t("pages.adminWhiteLabels.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("pages.adminWhiteLabels.subtitle")}
          </p>
        </div>
        <WhiteLabelsList />
      </section>
    </main>
  )
}
